import { Button, Col, DatePicker, Form, message, Row, Select } from "antd";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import configurationManagementService from "@services/configuationManagement.service";
import qs from "qs";
import moment from "moment";

const { Option } = Select;

/* eslint-disable no-template-curly-in-string */
const validateMessages = {
  required: "${label} is required!",
};
/* eslint-enable no-template-curly-in-string */

const Search = ({ loading }) => {
  const [mos, setMos] = useState([]);
  const [searchParams, setSearchParams] = useState({});

  const [form] = Form.useForm();

  const { search } = useLocation();
  const history = useHistory();

  const fetchMo = async (vendor) => {
    setMos([]);
    try {
      const res = await configurationManagementService.fetchMoList({
        vendor,
      });

      setMos(
        [...res.data].map((item, i) => (
          <Option key={i.toString(36) + i} value={item}>
            {item}
          </Option>
        ))
      );
    } catch (e) {
      message.error("Action has error",20);
      console.log(e);
    }
  };

  const handleFormValuesChange = async (changedValues) => {
    const formFieldName = Object.keys(changedValues)[0];
    if (
      formFieldName === "vendor" &&
      searchParams.vendor !== changedValues.vendor
    ) {
      form.setFieldsValue({ mo_name: "" });
      fetchMo(changedValues.vendor);
    }
  };

  const onFinish = async (values) => {
    try {
      history.push(
        `?${qs.stringify({
          ...values,
          datetime: moment(values.datetime).toISOString(),
        })}`
      );
    } catch (err) {
      message.error("Action has error",20);
      console.log(err);
    }
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(search);
    const params = Object.fromEntries(urlParams);
    setSearchParams(params);
  }, [search]);

  useEffect(() => {
    if (searchParams.vendor) fetchMo(searchParams.vendor || "");
    form.setFieldsValue({
      ...searchParams,
      oss: searchParams.oss || "OSS9",
      datetime: moment(searchParams.datetime),
    });

    // eslint-disable-next-line
  }, [searchParams]);

  return (
    <div className="bg-white rounded-md border border-gray-200 p-5">
      <Form
        form={form}
        layout="vertical"
        name="nest-messages"
        onFinish={onFinish}
        validateMessages={validateMessages}
        onValuesChange={handleFormValuesChange}
        initialValues={{
          oss: "OSS9",
        }}
      >
        <Row gutter={[14, 0]}>
          <Col xs={24} sm={24} md={12} lg={8} xl={6} xxl={4}>
            <Form.Item
              name="vendor"
              label="Vendor"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select>
                {/* <Option value="nokia">Nokia</Option> */}
                <Option value="huawei">Huawei</Option>
                {/* <Option value="ericsson">Ericsson</Option> */}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} lg={8} xl={6} xxl={4}>
            <Form.Item
              name="mo_name"
              label="MO Name"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select
                allowClear
                showSearch
                style={{ width: "100%" }}
                placeholder="Please select"
                // maxTagCount={0}
              >
                {mos}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} lg={8} xl={6} xxl={4}>
            <Form.Item
              name="datetime"
              label="Date"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <DatePicker className="w-full" format="" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} lg={8} xl={6} xxl={4}>
            <Form.Item
              name="oss"
              label="OSS"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select>
                <Option value="OSS9">OSS9</Option>
                <Option value="OSS10">OSS10</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col flex="auto" className="flex justify-end items-end">
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className="mt-4"
                disable={loading}
              >
                View
              </Button>
              <Button
                style={{ margin: "0 8px" }}
                onClick={() => {
                  form.resetFields();
                }}
              >
                Clear
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default Search;
